import _extends from "babel-runtime/helpers/extends";
import builder from "./util";

export default builder({
  getInitialState: function getInitialState() {
    return {
      questions: [],
      loading: true,
      error: null,
      hasViewedPopin: false
    };
  },
  actions: {
    setQuestions: function setQuestions(state) {
      return function (questions) {
        return _extends({}, state, { questions: questions, loading: false, error: null });
      };
    },
    setError: function setError(state) {
      return function (error) {
        return _extends({}, state, { error: error });
      };
    },
    hasViewedPopin: function hasViewedPopin(state) {
      return function () {
        return _extends({}, state, { hasViewedPopin: true });
      };
    }
  }
});
//# sourceMappingURL=app.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/stores/app.js
// module id = 97
// module chunks = 0